/* eslint-disable */
// @ts-nocheck
/* 注册防刷滑动验证码相关
 * @Author: WJL
 * @Date: 2020-03-31 20:14:40
 * @Last Modified by: wjl
 * @Last Modified time: 2022-12-21 17:26:37
 */
import { CAPTCHA_KEY } from '@/config/dev';

const APPKEY = CAPTCHA_KEY;
// const APPKEY = "FFFF0N0N000000002A2B";
const SCENE = 'nc_register_h5';
let nc = null;
let retryNum = 0;
/**
 *
 * @param {string} id  滑动验证需要渲染的目标元素ID。
 */
export const CaptchaInit = (id, success, fail) => {
  try {
    const dom = document.getElementById(id);
    if (!AWSC || !dom) {
      if (retryNum < 5) {
        retryNum = retryNum + 1;
        setTimeout(() => {
          CaptchaInit(id, success, fail)
        }, 500);
      }
      return;
    }
    AWSC.use('nc', (state, module) => {
      // 初始化
      nc = module.init({
        // 应用类型标识。它和使用场景标识（scene字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
        appkey: APPKEY,
        //使用场景标识。它和应用类型标识（appkey字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的scene值，请务必正确填写。
        scene: SCENE,
        // 声明滑动验证需要渲染的目标ID。
        renderTo: id,
        width: 280,
        upLang: {
          cn: {
            //加载状态提示。
            LOADING: '加载中...',
            //等待滑动状态提示。
            SLIDE: '请向右滑动验证',
            //验证通过状态提示。
            SUCCESS: '验证通过',
            //验证失败触发拦截状态提示。
            ERROR: '非常抱歉，网络出错了...',
            //验证失败触发拦截状态提示。
            FAIL: '验证失败，请重试',
          },
        },
        //前端滑动验证通过时会触发该回调参数。您可以在该回调参数中将会话ID（sessionId）、签名串（sig）、请求唯一标识（token）字段记录下来，随业务请求一同发送至您的服务端调用验签。
        success: function (data) {
          success && success({
            session_id: data.sessionId,
            sig: data.sig,
            token: data.token,
            scene: SCENE,
            csessionid: data.sessionId // 原生sdk使用
          })
        },
        // 滑动验证失败时触发该回调参数。
        fail: function (failCode) {
          fail && fail(e)
        },
        // 验证码加载出现异常时触发该回调参数。
        error: function (errorCode) {
          fail && fail(e)
        },
      });
    });
  } catch (error) {
    fail(error);
  }
};

export const CaptchaReset = () => {
  nc && nc.reset();
};
